import * as React from 'react';
import type { RenderFilterItemHandler } from '../types';
import StringFilterView from './StringFilterView';
import NumberFilterView from './NumberFilterView';
import BooleanFilterView from './BooleanFilterView';
import DateFilterView from './DateFilterView';
import EnumFilterView from './EnumFilterView';
import ReferenceFilterView from './ReferenceFilterView';
import AndOrFilterView from './AndOrFilterView';

export const renderFilterView: RenderFilterItemHandler = (opts) => {
    const { item, index, indent, availableFilters, allAvailableFilters, onChange, availableGroupingFilter, selectedLocale } = opts;

    switch (item.type) {
        case 'string':
            return <StringFilterView key={index} filterItem={item} availableFilters={availableFilters} onChange={onChange} />;
        case 'number':
            return <NumberFilterView key={index} filterItem={item} availableFilters={availableFilters} onChange={onChange} />;
        case 'boolean':
            return <BooleanFilterView key={index} filterItem={item} availableFilters={availableFilters} onChange={onChange} />;
        case 'date':
            return <DateFilterView key={index} filterItem={item} availableFilters={availableFilters} onChange={onChange} />;
        case 'enum':
            return <EnumFilterView key={index} filterItem={item} availableFilters={availableFilters} onChange={onChange} />;
        case 'reference':
            return (
                <ReferenceFilterView key={index} filterItem={item} availableFilters={availableFilters} onChange={onChange} selectedLocale={selectedLocale} />
            );
        case 'and':
        case 'or':
            return (
                <AndOrFilterView
                    key={index}
                    availableGroupingFilter={availableGroupingFilter}
                    allAvailableFilters={allAvailableFilters}
                    indent={indent}
                    locale={selectedLocale}
                    filterItem={item}
                    renderFilterItem={renderFilterView}
                    onChange={onChange}
                    deletable={indent > 0}
                />
            );
        default: {
            const _exhaustiveCheck: never = item;
            return _exhaustiveCheck;
        }
    }
};
